<template>
  <motlet :options="motletOptions">
    <template #content>
      <!-- eslint-disable-next-line prettier/prettier -->
      <bar-horizontal-stack
        :system="system"
        :items="instances"
        :values="values"
        :selected-descendant.sync="selectedDescendant"
        :contextmenu="contextmenuChart"
      />
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import { cloneDeep } from 'lodash';
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import BarHorizontalStack from '../chart/BarHorizontalStack.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    BarHorizontalStack,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/abap/WorkProcess',
        title: 'Work Process',
      },
      messageName: 'rawWorkprcs',
      messageFields: ['wpIstatus', 'wpStatus'],
      // messageName: 'cntWorkprcsTypeStatus',
      // messageFields: ['wpItype', 'wpIstatus'],
      messageSequence: 0,
      values: [],
      recieve: {},
      contextmenuUrl: '/views/detailview/abap/process',
      selectedDescendant: {},
    };
  },
  watch: {
    instances: {
      handler: 'changeInstancesHandler',
    },
  },
  methods: {
    contextmenuChart(event) {
      this.onContextmenuChart(event, this.selectedDescendant);
    },
    //BEGIN::Removed.by.KWShin.
    // 어차피 Buffered data의 마지막 건만 필요한 경우
    // 구독 시 buffer() handler를 안 보내면
    // 서버에서 Buffered data의 마지막 건만 every() handler로 보내도록 수정함.
    // wsBufferedDataHandler(key, responses, every) {
    //   responses.forEach(response => {
    //     if (response.length) {
    //       const last = response.length ? response[response.length - 1] : { data: [], ctime: '', empty: true };
    //       every(key, last.data, last.ctime, last.empty);
    //     }
    //   });
    // },
    //FINISH::Removed.by.KWShin.
    wsDataHandler(key, response) {
      // console.log('WorkProcess every()', response);
      ++this.messageSequence;
      // 인스턴스 마다 값을 누적한다.
      this.recieve[key.instId] = [];
      response.forEach(res => {
        if (!this.recieve[key.instId].find(v => v.code == res.wpIstatus)) this.recieve[key.instId].push({ value: 0, code: parseInt(res.wpIstatus), name: res.wpStatus });
        this.recieve[key.instId].find(v => v.code == res.wpIstatus).value++;
      });

      // 시스템에 속한 인스턴스들의 값이 모두 취합 된 후
      if (this.messageSequence == this.instances.length) {
        this.messageSequence = 0;
        const recieve = cloneDeep(this.recieve);
        // 취합된 값의 종류별 값을 모두 발췌한다.
        const codes = Object.keys(recieve).reduce((acc, id) => {
          recieve[id].forEach(value => (acc[value.code] = value.name));
          return acc;
        }, {});
        // 모든 종류별 값을 포함하고 있는 상태로 재구성한다.
        this.values = this.instances.map(item => {
          return Object.keys(codes)
            .sort((a, b) => a - b)
            .map(code => ({
              code,
              name: codes[code],
              value: (recieve[item.id].find(value => value.code == code) || {}).value || 0,
            }));
        });
        // console.log('WorkProcess this.values', this.values);
      }
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.instances.map(instance => ({
          key: { name: this.messageName, sstmId: instance.systemId, instId: instance.id },
          fields: this.messageFields,
          empty: false,
          handler: {
            // buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        })),
      });
    },
    initialize() {
      this.messageSequence = 0;
      // websoket message init
      this.wsRequestMessages = {};
      this.recieve = {};
    },
    changeInstancesHandler() {
      this.initialize();
      this.sendMessage();
    },
  },
};
</script>
